<template>
    <FitHalfScreenDialog :appendToBody="true" class="scan-gift-merchants" :title="info.title" :visible="visible"
        @onClose="handleClose">
        <div class="content">
            <img v-if="info.content" :src="info.content">
        </div>
    </FitHalfScreenDialog>
</template>

<script lang="ts" setup>
import { FitHalfScreenDialog } from '@tencent/wphk-ui';

defineProps<{
  visible: boolean,
  info: { title: string, content: string }
}>();
const emits = defineEmits(['close']);

function handleClose() {
  emits('close');
}

</script>

<style lang="less" scoped>
@import (reference) '~@/less/main';

.scan-gift-merchants {
    /deep/ .weui-half-screen-dialog {
        background-image: url(./assets/dialog-bg.png);
        background-position: bottom center;
        background-repeat: no-repeat;
        min-height: 300 /@rem;
        background-size: 100%;
    }

    .content {
        padding: 8 /@rem 26 /@rem 12 /@rem 26 /@rem;

        img {
            width: 100%;
        }
    }
}
</style>

